// extracted by mini-css-extract-plugin
export var legendIndicator = "_f5-1";
export var legendRight = "_f5-0";